//messageType,handler
import {Message} from "element-ui";
import getHsitoryMessages from "@/api/chat/getHsitoryMessages";

let groupMessageCallbacks = []
let groupDeleteCallbacks = []

let registerGroupMessageCallback = function (callback) {
    if (callback && groupMessageCallbacks.indexOf(callback) === -1) {
        groupMessageCallbacks.push(callback)
    }
}

let unregisterGroupMessageCallback = function (callback) {
    groupMessageCallbacks = groupMessageCallbacks.filter(cb => cb !== callback)
}

let registerGroupDeleteCallback = function (callback) {
    if (callback && groupDeleteCallbacks.indexOf(callback) === -1) {
        groupDeleteCallbacks.push(callback)
    }
}

let unregisterGroupDeleteCallback = function (callback) {
    groupDeleteCallbacks = groupDeleteCallbacks.filter(cb => cb !== callback)
}

let getHistoryMessagesFromSQL = async function(token,that){
    console.log('从数据库获取消息')
    //获取未读消息的最新20条，和每个用户的未读count
    //获取之后，先将historyMessage缓存清除，再添加进去
    getHsitoryMessages().then(res=>{
        if(res.code===1){
            that.clearHistoryMessage()
            let data = res.data
            for(let i=0;i<data.length;i++){
                that.addToHistoryMessage(data[i])
            }
        }
    })
}


let handlerMap = new Map()
let customerServerOnlineResponseMessageHanlder = function (message){
    Message({message:message.msg, type:'success'})
}
let ChatResponseMessageHandler = function (message,that) {
    that.addToHistoryMessage(message)
}
let HeartBeatRequestMessageHandler = function(){
    // console.log('服务器存活！')
}
let ChatGroupResponseMessageHandler = function (message) {
    groupMessageCallbacks.forEach(cb => cb(message))
}
let ChatGroupDeleteResponseMessageHandler = function (message) {
    groupDeleteCallbacks.forEach(cb => cb(message))
}
let ChatGroupRevokeResponseMessageHandler = function (message) {
    groupDeleteCallbacks.forEach(cb => cb(message))
}
handlerMap.set(0,customerServerOnlineResponseMessageHanlder)
handlerMap.set(2,ChatResponseMessageHandler)
handlerMap.set(5,HeartBeatRequestMessageHandler)
handlerMap.set(7, ChatGroupResponseMessageHandler)
handlerMap.set(8, ChatGroupDeleteResponseMessageHandler)
handlerMap.set(10, ChatGroupRevokeResponseMessageHandler)

let processMessage = function (message,that){
    const messageType = Number(message.messageType)
    const handler = handlerMap.get(messageType)
    if (handler) {
        handler(message, that)
    }
}

export {
    processMessage,
    getHistoryMessagesFromSQL,
    registerGroupMessageCallback,
    unregisterGroupMessageCallback,
    registerGroupDeleteCallback,
    unregisterGroupDeleteCallback,
}